import { render, staticRenderFns } from "./AgentQa.vue?vue&type=template&id=43cdd63a&scoped=true"
import script from "./AgentQa.vue?vue&type=script&lang=js"
export * from "./AgentQa.vue?vue&type=script&lang=js"
import style0 from "./AgentQa.vue?vue&type=style&index=0&id=43cdd63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cdd63a",
  null
  
)

export default component.exports